import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Image from 'next/image'
import { RegularSection, ColorTitle } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'

interface ImageData {
    src?: string
    alt?: string
}

interface Content {
    title?: string
    text1?: string
    text2?: string
    image?: ImageData
}

interface S3_about_5Props {
    content?: Content
    blockName?:string
}

const defaultContent: Content = {
    title: 'Who We Are',
    text1: 'Skilled European Team with Years of Experience',
    text2: "You will get expert service backed by years of hands-on experience across every type of job — from residential renovations to high-stakes industrial projects. We've cut concrete underwater for hydro power plants, handled complex demolitions like bridges without disrupting traffic, and bring that same precision to every job we take on. With custom-built equipment, advanced techniques, and a European-trained team, we deliver results that are clean, efficient, and tailored exactly to your site's needs.",
    image: { src: '/img/img-160400.jpg', alt: 'man cutting concrete' },
}

const Index = (props: S3_about_5Props) => {
    const { content = defaultContent } = props
    const { title, text1, text2, image = {}} = content
    const heroImage = getImageData(image)
    return (
        <RegularSection aria-label='S3_about_5' >
            <Grid
                container
                spacing={4}
            >
                <Grid
                    size={{ xs: 12, md: 6, lg: 7 }}
                    sx={{ display: 'flex', flexDirection: 'column', gap: 2, justifyContent: 'center' }}
                >
                    <ColorTitle title={title} colorFrom={0} textAlign='start'/>
                    <Typography variant='body2'>{text1}</Typography>
                    <Typography variant='body1'>{text2}</Typography>
                </Grid>
                <Grid
                    size={{ xs: 12, md: 6, lg: 5 }}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 5,
                        overflow: 'hidden',
                    }}
                >
                    {heroImage.src ? (
                        <Image
                            src={heroImage.src}
                            alt={heroImage.alt || ''}
                            width={670}
                            height={360}
                            style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
                        />
                    ) : null}
                </Grid>
            </Grid>
        </RegularSection>
    )
}

export default Index
